import React, { useContext, useEffect } from "react";
import AuthContext from "../../context/AuthContext";

const Sidebar = ({ isOpen, onClose }) => {
const {logoutUser } = useContext(AuthContext);

  // Fetch technician options from API (if needed in the future)
  useEffect(() => {
    // Fetch logic can go here
  }, []);

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "250px",
        height: "100%",
        backgroundColor: "#2c3e50",
        color: "#ecf0f1",
        boxShadow: "2px 0 5px rgba(0, 0, 0, 0.5)",
        zIndex: 1000,
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "15px 20px",
          backgroundColor: "#34495e",
          borderBottom: "1px solid #2c3e50",
        }}
      >
        <h2 style={{ margin: 0, fontSize: "18px" }}>CON TICKETS</h2>
        <button
          style={{
            background: "none",
            border: "none",
            color: "#ecf0f1",
            fontSize: "20px",
            cursor: "pointer",
          }}
          onClick={onClose}
        >
          ✖
        </button>
      </div>
      <aside style={{ padding: "15px" }}>
        <nav>
          <ul
            style={{
              listStyleType: "none",
              padding: 0,
              margin: 0,
            }}
          >
            {[
              "Dashboard",
              "My Account",
              "Reports",
              "Technicians",
              "Feedback",
            ].map((item, index) => (
              <li
                key={index}
                style={{
                  padding: "10px 15px",
                  borderBottom: "1px solid #34495e",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#1abc9c")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "transparent")
                }
              >
                {item}
              </li>
            ))}
            {/* External Links */}
            <li
              style={{
                padding: "10px 15px",
                borderBottom: "1px solid #34495e",
                cursor: "pointer",
              }}
            >
              <a
                href="https://cableone-ke.smartolt.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "#ecf0f1",
                  display: "block",
                  width: "100%",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#1abc9c")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "transparent")
                }
              >
                Smart OLT
              </a>
            </li>
            <li
              style={{
                padding: "10px 15px",
                borderBottom: "1px solid #34495e",
                cursor: "pointer",
              }}
            >
              <a
                href="https://app.one-isp.net"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "#ecf0f1",
                  display: "block",
                  width: "100%",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#1abc9c")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "transparent")
                }
              >
                One ISP
              </a>
            </li>
                            <li>
                    <button onClick={logoutUser} className="btn btn-sm btn-warning">Logout</button>
                </li>
          </ul>
        </nav>
      </aside>
    </div>
  );
};

export default Sidebar;
